import { companyNameModel } from '../forms/company-name-form/companyNameModel.js';
import { otpModel } from '../forms/otp-form/otpModel.js';
import { phoneNumModel } from '../forms/phone-num-form/phoneNumModel.js';
import { serviceTypeModel } from '../forms/service-type-form/serviceTypeModel.js';

const LoginFormModel = {
    phoneNum: phoneNumModel,
    otp: otpModel,
    companyName: companyNameModel,
    serviceType: serviceTypeModel,
    success: {
        id: "success",
        fields: {}
    }
};

export { LoginFormModel };
//# sourceMappingURL=login-form-model.js.map
